import { reactive } from 'vue';
import axios from 'axios';

export const auth = reactive({
    user: JSON.parse(localStorage.getItem('user')),
    token: localStorage.getItem('token'),
    get isLoggedIn() { return !!this.token; },
    setAuth(user, token) {
        this.user = user;
        this.token = token;
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('token', token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    clearAuth() {
        this.user = null;
        this.token = null;
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
    },
});

if (auth.token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${auth.token}`;
}
